const Title = () => {
  return (
    <div className="flex w-full items-end justify-center">
      <div className="flex items-center flex-col w-[1153px]">
        <h1 className="text-6xl font-bold text-center">Why do Businesses use Redact?</h1>
        <p className="text-slate-300 text-lg text-center">
          The only service that enables your organization to privately and securely automate content
          deletion from platforms like Twitter, Instagram, Facebook and more — all in one place.
        </p>
      </div>
    </div>
  );
};

export default Title;
